import {
  DRAWINGTOOLBAR_SWITCH_TO_ADD_MODE,
  DRAWINGTOOLBAR_SWITCH_TO_REMOVE_MODE,
  DRAWINGTOOLBAR_SWITCH_TO_INSERTA_TEE_MODE,
  DRAWINGTOOLBAR_BACKGROUND_FILE_SELECTED,
  DRAWINGTOOLBAR_BACKGROUND_SHOW_HIDE,
  DRAWINGTOOLBAR_CHANBERS_AUTOFILL,
  DRAWINGTOOLBAR_CHANBERS_AUTOEMTPY,
  DRAWINGTOOLBAR_ENDCAPS_AUTOADD,
  DRAWINGTOOLBAR_BACKGROUND_LOADED,
  DRAWINGTOOLBAR_BACKGROUND_EDIT,
  DRAWINGTOOLBAR_SCALE_UNIT_VALUE_CHANGE,
  DRAWINGTOOLBAR_CHAMBER_ROW_SPACING_VALUE_CHANGE,
  DRAWINGTOOLBAR_SCALE_EDIT,
  DRAWINGTOOLBAR_MEASURETOOL_EDIT,
  BULKADDREMOVETOOL_EDIT,
  BACKGROUND_IMAGE_LOADED,
  BACKGROUND_SHOW_HIDE,
  BACKGROUND_EDIT,
  DRAWINGTOOLBAR_SWITCH_TO_INSPECTION_PORT_MODE,
  DRAWINGTOOLBAR_SWITCH_TO_INLET_MANIFOLD_MODE,
  DRAWINGTOOLBAR_SWITCH_TO_OUTLET_MANIFOLD_MODE,
  DRAWINGTOOLBAR_SWITCH_SELECTOR_MODE,
  PIPE_GLOBALS_SET_SCALE_VALUE,
  GLOBAL_PROJECT_TYPE_CHAMBER,
  DRAWINGTOOLBAR_CLEAR_RULERS_ON_SCREEN
} from "../lib/types";

/* BACKGROUND ACTIONS */
export const backgroundFileSelected = file => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_BACKGROUND_FILE_SELECTED,
    payload: file
  });
};

export const backgroundLoaded = bgImg => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_BACKGROUND_LOADED,
    payload: bgImg
  });
  dispatch({
    type: BACKGROUND_IMAGE_LOADED,
    payload: bgImg
  });
};

export const backgroundShowHide = bgShow => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_BACKGROUND_SHOW_HIDE,
    payload: !bgShow
  });
  dispatch({
    type: BACKGROUND_SHOW_HIDE,
    payload: !bgShow
  });
  /* if background is set to hide, disable the edit mode */
  if (!bgShow === false) {
    dispatch({
      type: DRAWINGTOOLBAR_BACKGROUND_EDIT,
      payload: false
    });
    dispatch({
      type: BACKGROUND_EDIT,
      payload: false
    });
  }
};

export const backgroundEdit = bgEdit => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_BACKGROUND_EDIT,
    payload: !bgEdit
  });
  dispatch({
    type: BACKGROUND_EDIT,
    payload: !bgEdit
  });
};

export const scaleEditSwitch = scaleEdit => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_SCALE_EDIT,
    payload: !scaleEdit
  });
};

export const measureToolEditSwitch = measureToolEdit => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_MEASURETOOL_EDIT,
    payload: !measureToolEdit
  });
};

export const bulkAddRemoveToolEditSwitch = bulkAddRemoveToolEdit => dispatch => {
  dispatch({
    type: BULKADDREMOVETOOL_EDIT,
    payload: !bulkAddRemoveToolEdit
  });
};

export const scaleUnitValueChange = scaleValue => ( dispatch, getState ) => {
  const { projectType } = getState().globals;

  dispatch({
    type: projectType === GLOBAL_PROJECT_TYPE_CHAMBER
      ? DRAWINGTOOLBAR_SCALE_UNIT_VALUE_CHANGE
      : PIPE_GLOBALS_SET_SCALE_VALUE,
    payload: scaleValue
  });
};

export const chamberRowSpacingValueChange = chamberRowSpacing => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_CHAMBER_ROW_SPACING_VALUE_CHANGE,
    payload: chamberRowSpacing
  });
};

export const chambersAutofill = () => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_CHANBERS_AUTOFILL
  });
};

export const chambersAutoEmpty = () => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_CHANBERS_AUTOEMTPY
  });
};

export const endCapsAutoAdd = requiredChamberSlotsforTwoEndcaps => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_ENDCAPS_AUTOADD,
    payload: {
      requiredChamberSlotsforTwoEndcaps
    }
  });
};

export const switchToAddMode = () => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_SWITCH_TO_ADD_MODE
  });
};

export const switchToRemoveMode = () => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_SWITCH_TO_REMOVE_MODE
  });
};

export const switchToInsertaTeeMode = () => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_SWITCH_TO_INSERTA_TEE_MODE
  });
};

export const switchToInspectionPortMode = () => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_SWITCH_TO_INSPECTION_PORT_MODE
  });
};

export const switchToInletManifoldMode = () => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_SWITCH_TO_INLET_MANIFOLD_MODE
  });
};

export const switchToOutletManifoldMode = () => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_SWITCH_TO_OUTLET_MANIFOLD_MODE
  });
};

export const switchDrawingSelectorMode = drawingSelectorMode => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_SWITCH_SELECTOR_MODE,
    payload: drawingSelectorMode
  });
};

export const clearRulersOnScreen = () => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_CLEAR_RULERS_ON_SCREEN
  });

  dispatch({
    type: DRAWINGTOOLBAR_SCALE_EDIT,
    payload: false
  });

  dispatch({
    type: DRAWINGTOOLBAR_MEASURETOOL_EDIT,
    payload: false
  });
};



// WEBPACK FOOTER //
// ./src/actions/drawingtoolbar-actions.js